import { render, staticRenderFns } from "./ShippingConfig.vue?vue&type=template&id=8722ff72&"
import script from "./ShippingConfig.vue?vue&type=script&lang=js&"
export * from "./ShippingConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShippingConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports